// src/pages/AddRecipePage.tsx

import React from 'react';
import AddRecipeForm from '../components/recipes/AddRecipeForm';
import { useNavigate } from 'react-router-dom';
import { Page } from '../components/ui';

const AddRecipePage: React.FC = () => {
  const navigate = useNavigate();

  const handleRecipeAdded = () => {
    // Optionally navigate to home or favorites after adding
    navigate('/');
  };

  return (
    <Page marginTop={4} marginBottom={5}>
      <AddRecipeForm onRecipeAdded={handleRecipeAdded} />
    </Page>
  );
};

export default AddRecipePage;
